// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ui-fade-rise {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes ui-card-stagger {
  from {
    opacity: 0;
    transform: translateY(6px) scale(0.995);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.app-header,
.view-tabs-shell,
.filters,
.summary-grid,
.board,
.approved-view,
.tax-view,
.control-overview,
.attendance-view,
.locations-panel {
  animation: ui-fade-rise var(--motion-slow) var(--easing-emphasis) both;
}

.summary-card,
.approved-card,
.log-item,
.attendance-export-item,
.tax-summary-card {
  animation: ui-card-stagger var(--motion-base) var(--easing-standard) both;
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 1ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 1ms !important;
    scroll-behavior: auto !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/motion.css"],"names":[],"mappings":"AAAA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;;;;;;;;;;EAUE,sEAAsE;AACxE;;AAEA;;;;;EAKE,yEAAyE;AAC3E;;AAEA;EACE;;;IAGE,kCAAkC;IAClC,uCAAuC;IACvC,mCAAmC;IACnC,gCAAgC;EAClC;AACF","sourcesContent":["@keyframes ui-fade-rise {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes ui-card-stagger {\n  from {\n    opacity: 0;\n    transform: translateY(6px) scale(0.995);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.app-header,\n.view-tabs-shell,\n.filters,\n.summary-grid,\n.board,\n.approved-view,\n.tax-view,\n.control-overview,\n.attendance-view,\n.locations-panel {\n  animation: ui-fade-rise var(--motion-slow) var(--easing-emphasis) both;\n}\n\n.summary-card,\n.approved-card,\n.log-item,\n.attendance-export-item,\n.tax-summary-card {\n  animation: ui-card-stagger var(--motion-base) var(--easing-standard) both;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 1ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 1ms !important;\n    scroll-behavior: auto !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
